import { createSelector } from "reselect";
import {
  GetExchangeSignalByIdRequest,
  Selector,
  SignalGeneralExtraData,
} from "@shared/types";
import { skipToken } from "@reduxjs/toolkit/query";
import { sharedLib } from "@shared/services/shared.service";

// GeneralTradeInfo Info
export const selectSignalGeneralInfo = (
  args: GetExchangeSignalByIdRequest | undefined
): Selector<SignalGeneralExtraData | undefined> =>
  createSelector(
    sharedLib.sharedApi.signals.endpoints.getSignalExtraInfoGeneral.select(
      args ?? skipToken
    ),
    (signalExtraInfoData) => signalExtraInfoData.data
  );

// Targets selectors
export const selectSignalTargets = (
  args: GetExchangeSignalByIdRequest | undefined
) =>
  createSelector(
    sharedLib.sharedApi.signals.endpoints.getSignalExtraInfoTargets.select(
      args ?? skipToken
    ),
    (signalExtraInfoData) => signalExtraInfoData.data
  );

export const selectSignalTargetsPrecision = (
  args: GetExchangeSignalByIdRequest | undefined
) =>
  createSelector(
    selectSignalTargets(args),
    (signalTargets) => signalTargets?.precision
  );
export const selectSignalTargetsData = (
  args: GetExchangeSignalByIdRequest | undefined
) =>
  createSelector(
    selectSignalTargets(args),
    (signalTargets) => signalTargets?.data
  );
